.fc{outline:none;}